import { getThemeForKey, Styles } from "@mcleod/core";

export const CheckboxStyles = Styles.make("chk", () => {
    const commonImageStyles = {
        display: "flex", alignItems: "center", outline: "none",
    }
    return {
        checkBase: { display: "flex", alignItems: "center", userSelect: "none" },
        checked: {}, //exists solely so we can tell if the box is checked from the CSS styles (for test automation)
        image: {
            ...commonImageStyles,
            "&:focus-within": getThemeForKey("checkbox.styleHoverCircle"),
            "&:hover": getThemeForKey("checkbox.styleHoverCircle")
        },
        imageDisabled: {
            ...commonImageStyles,
        },
        indeterminate: {}, //exists solely so we can tell if the box is checked from the CSS styles (for test automation)
        unchecked: {} //exists solely so we can tell if the box is checked from the CSS styles (for test automation)
    };
});
